import axios from 'axios'
import $ from 'jquery';
import { Message, MessageBox } from 'element-ui' 
let baseIp = 'http://49.233.146.162:8022' 
const instance = axios.create({
  baseURL: baseIp,
  timeout: 60000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  },
  validateStatus: function (status) {
    return status >= 200 && status <= 304
  }
})
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (err) {
  // 对请求错误做些什么
  return Promise.reject(err)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  return response
}, function (err) {
  if (err.response.status === 306) {
    if (err.response.data.code === 800) {
      $('.el-message-box').length && MessageBox.close()
      MessageBox.confirm('会话超时，请重新登录！', '会话超时', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        closeOnClickModal: false
      }).then(() => {
        // 点确定跳转到登录页
        // err.response.data.data && (window.location.href = err.response.data.data)
        window.location.href = baseIp + '/logout'
      }).catch(() => {
      })
    } else if (err.response.data.code === 801) {
      Message.error('很抱歉！您没有访问权限！权限校验失败!')
    }
  }
  return Promise.reject(err)
})
export default instance



// WEBPACK FOOTER //
// ./src/service/Axios.js